export default "__VITE_ASSET__BjI40O4i__"